export default __webpack_public_path__ + "static/media/banner-guarantees-mobile.b33a62bc.png";